/**
 * Asset table and card fields share these formatters so equivalent metadata
 * has identical compact presentation across both review surfaces.
 */
const UNAVAILABLE_VALUE = '—';
const SECONDS_PER_MINUTE = 60;

export function formatVideoDuration (seconds: unknown): string {
  if (
    typeof seconds !== 'number' ||
    !Number.isFinite(seconds) ||
    seconds < 0
  ) {
    return UNAVAILABLE_VALUE;
  }

  const wholeSeconds = Math.floor(seconds);
  const minutes = Math.floor(wholeSeconds / SECONDS_PER_MINUTE);
  const remainingSeconds = wholeSeconds % SECONDS_PER_MINUTE;

  return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
}

export function formatDimensions (
  width?: number,
  height?: number,
): string {
  if (width === undefined || height === undefined) return UNAVAILABLE_VALUE;

  return `${width}×${height}`;
}
